
export default {
  props: {
    extraClasses: {
      type: String,
      required: false,
      default: null,
    },
    links: {
      type: Object,
      default() {
        return {}
      },
    },
    animated: {
      type: Boolean,
      default: false,
    },
    x: {
      type: [String, Boolean],
      default: 'left',
    },
    y: {
      type: [String, Boolean],
      default: 'bottom',
    },
  },
  data() {
    return {
      isActive: false,
      overlay: null,
    }
  },
  mounted() {
    const layout = document.getElementById('layout')
    const overlay = document.createElement('DIV')

    // add overlay to close popover
    overlay.setAttribute('class', `none lg:hidden inset-0 transition-opacity`)
    overlay.setAttribute('id', `overlay-popover`)
    overlay.addEventListener('click', () => {
      if (this.isActive) {
        this.show(false)
      }
    })

    layout.appendChild(overlay)

    this.setElement()
  },
  methods: {
    show(state) {
      if (this.overlay === null) {
        this.setElement()
      }

      // hide overlay if inactive state
      if (state) {
        this.overlay.classList.remove('none')
        this.overlay.classList.add('fixed')
      } else {
        this.overlay.classList.add('none')
        this.overlay.classList.remove('fixed')
      }

      this.isActive = state
    },
    setElement() {
      this.overlay = document.querySelector('#overlay-popover')
    },
  },
}
